<div fxLayout="column">
  <mat-radio-group [(ngModel)]="pause_reason_id" fxLayout="column">
    <mat-radio-button *ngFor="let pause_reasons of pause_reasons" [value]="pause_reasons.id" class="pause-reason-option pb-1">
      {{ pause_reasons.label | translate }}
    </mat-radio-button>
  </mat-radio-group>
</div>
